module.exports = __webpack_public_path__ + "media/bootstrap-icons/files-6827507e.svg";